export const MODAL_FADE_IN_TIME = 200; // in ms
export const MODAL_FADE_OUT_TIME = 200; // in ms
export const MODAL_IMAGE_TRANSITION_TIME = 200; // in ms
